import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { theme } from "./theme/appTheme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { StoreDetailsContext, UserDetailsContext } from "./contexts/entityDetailsContext";
import { LoggedInUserDetails, LoggedInUserStoreDetails } from "./models/inbox";
import Inbox from "./pages/inbox";
import ConnectUser from "./pages/userConnection";
import ChatiFrame from "./pages/chatiFrame";
import Followers from "./pages/followers";
import NewChat from "./pages/newChat";
import SearchUser from "./pages/searchUser";
import StoreInbox from "./pages/storeInbox";
import StoreFollowers from "./pages/storeFollowers";
import StoreMessageRequest from "./pages/messageRequests";
import "./styles/material.css";
import "./styles/styles.css";
import "./styles/components/commonComponent.css";

const App = () => {
  const [userDetails, setUserDetails] = useState<LoggedInUserDetails>();
  const [storeDetails, setStoreDetails] = useState<LoggedInUserStoreDetails>();

  return (
    <UserDetailsContext.Provider value={{ userDetails, setUserDetails }}>
      <StoreDetailsContext.Provider value={{ storeDetails, setStoreDetails }}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<Inbox />} />
              <Route exact path="/chat" element={<ChatiFrame />} />
              <Route exact path="/connection" element={<ConnectUser />} />
              <Route exact path="/followers" element={<Followers />} />
              <Route exact path="/chats" element={<NewChat />} />
              <Route exact path="/search" element={<SearchUser />} />
              <Route exact path="/store-inbox" element={<StoreInbox />} />
              <Route exact path="/store-followers" element={<StoreFollowers />} />
              <Route exact path="/store-requests" element={<StoreMessageRequest />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </StoreDetailsContext.Provider>
    </UserDetailsContext.Provider>
  );
};

export default App;
